<template>
  <div>
    <el-table
      :data="tableData"
      :stripe="stripe"
      style="width: 100%;"
      :height="height"
      :cell-style="{padding:'2px'}">
      <el-table-column
        v-for="(n, index) in columnLabel"
        :key="index"
        :sortable="n.sortable"
        :width="n.width"
        :label="n.label">
        <template slot-scope="scope">
          <div class="flex col-2 m-4" >
            <el-skeleton-item
              variant="p"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
	name: 'table-skeleton',

	computed : {
    tableData () {
      return [...Array(this.rows).keys()]
    },
    tableColumns () {
      return [...Array(this.columns).keys()]
    },
	},
	components : {
	},
	props: {
    stripe: {
      type: Boolean,
      default: true
    },
    rows: {
      type: Number,
      required: true,
      default: 6,
    },
    height: {
      type: Number,
      default: 239,
    },
    columnLabel : {
      type: Array,
      default : () => ['test','test','test','test','test','test'],
    }

	}
}
</script>
